import React from "react";
import { SetupTab } from "areas/shared/pages/setup";
import * as API from "modules/app/API";
import EmailInfoComp from './EmailInfoComp';
import * as Formatting from "fw/misc/Formatting";

class EmailInfoTab extends SetupTab {

    privileges() {
        return {};
    }

    urls() {
        return {
            get: API.Emailing.url('/Emails/Retrieve'),
        };
    }

    getRequest(selectedId) {
        return {
            emailKey: selectedId,
        };
    }

	ready() {
		let form = this.state.form;
		form.title = Formatting.formatClientDateTime(form.createDate) + ": " + form.subject;

        this.setState(form);
    }

	renderContent() {
        return (
			<EmailInfoComp emailInfo={this.state.form} emailKey={this.props.selectedId} />
        );
    }
}

export default EmailInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/emailingLog/emailInfo/EmailInfoTab.js